import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./DiscoveryManagement.scss";
import "../../styles/global.scss";
import "../../styles/pagelayout.scss";

// React Bootstrap components
import { Container, Row, Col, Button } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Auth from "@aws-amplify/auth";
import Sidebar from "../components/sidebar/Sidebar";
import Cookies from "js-cookie";
import Navbar from "../components/header/NavBar";
import { GetUserProfile } from "../../API/endpoints/User";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { Avatar, Divider } from "@mui/material";
import ChipWithIcon from "../components/Chip/ChipWithIcon";
import DocumentItem from "../components/documentItem/DocumentItem";
import PartnerApproval from "../components/modalForms/DiscoveryManagement/PartnerApproval";
import {
  GetBrandRequests,
  expressInterestByPartner,
  getBrandRequestByID,
} from "../../API/endpoints/Discovery";
import ConfirmModal from "../components/Modal/ConfirmModal";
import { sendPartnerInterestExpressedEmail } from "../../API/endpoints/Email";
import { CreateTodo } from "../../API/endpoints/Todos";
import { CreateActivity } from "../../API/endpoints/Dashboard";
import { abbreviateNumber, getLogoPlaceHolder } from "../../common/helpers";
import PartnerChat from "./PartnerChat";

function BrandRequestPartnerView() {
  const navigate = useNavigate();

  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [roleID, setRoleID] = useState<string | undefined>("");
  const [permissions, setPermissions] = useState<any>([]);
  const [requestDetails, setRequestDetails] = useState<any>({});
  const [brandDetails, setBrandDetails] = useState<any>({});
  const [marketPlaceDetails, setMarketPlaceDetails] = useState<any[]>([]);
  const [socialMedialDetails, setSocialMediaDetails] = useState<any[]>([]);
  const [brandDocumentsList, setBrandDocumentsList] = useState<any[]>([]);
  const [reload, setReload] = useState<boolean>(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [chatData, setChatData] = useState({} as any);

  const [expresInterestModal, setExpresIneterestModal] = useState(false);

  const confirmLogOut = (): void => {
    setExpresIneterestModal(true);
  };

  const handleChatModal = () => {
    setShowChatModal(false);
  };

  const onExpressInterest = async () => {
    const reqData = {
      discovery_brands_id: params?.id,
      partner_id: userProfile?.partnerv2_id,
      services: requestDetails?.brand_services?.map((service: any) => {
        return { service_id: service.service_id, status: "Awaiting response" };
      }),
      status: "New",
    };

    try {
      setExpresIneterestModal(false);
      //  console.log(formData);
      const res = await expressInterestByPartner(reqData);
      setReload(!reload);
      await sendPartnerInterestExpressedEmail({
        discovery_brands_id: res.data.discovery_brands_id,
        partner_id: res.data.partner_id,
      });
      try {
        const todoData = {
          id: `partner-interest:${res?.data?.id}`,
          brand_id: requestDetails?.brand_id,
          partner_id: res.data.partner_id,
          message: `<b>${userProfile?.partner?.company_name}</b> has expressed interest to your request for <b>${requestDetails?.country?.name}</b>.`,
          url: `/discoverymanagement-brands/${res.data.discovery_brands_id}&&${requestDetails?.brand?.brand_name}`,
          url_action: "Please review and accept if suitable.",
          visibility: "active users",
          permission_submodule_id: 31,
          admin: false,
          brand: true,
        };
        const todoData2 = {
          id: `partner-interest-admin:${res?.data?.id}`,
          brand_id: requestDetails?.brand_id,
          partner_id: res.data.partner_id,
          message: `<b>${userProfile?.partner?.company_name}</b> has expressed an interest for <b>${requestDetails?.brand?.brand_name}</b> request in <b>${requestDetails?.country?.name}</b>.`,
          url: `/discoverymanagement-recommend/${res.data.discovery_brands_id}&&${requestDetails?.brand?.brand_name}&&recommendation`,
          url_action: "Click to view the details.",
          permission_submodule_id: 15,
          admin: true,
        };
        const todoData3 = {
          id: `partner-interest-partner:${res?.data?.id}`,
          brand_id: requestDetails?.brand_id,
          partner_id: res.data.partner_id ? res.data.partner_id : "",
          message: `You have expressed interest for brand <b>${requestDetails?.brand?.brand_name}</b> request in <b>${requestDetails?.country?.name}</b>.`,
          url: `/discoverymanagement/partner`,
          url_action: "Click to view the details.",
          visibility: "active users",
          permission_submodule_id: 39,
          admin: false,
          partner: true,
        };
        const res2 = await CreateTodo(todoData);
        const res3 = await CreateTodo(todoData2);
        const res4 = await CreateTodo(todoData3);
        console.log(res2);
        console.log(res3);
        console.log(res4);
        const activity = await CreateActivity(
          `Partner ${userProfile?.partner?.company_name} has expressed an interest for brand: ${requestDetails?.brand?.brand_name} request in ${requestDetails?.country?.name}.`
        );
        console.log(activity);
      } catch (e) {
        console.log(e);
      }
      closeExpresInterestModal();
    } catch (ex) {
      console.log(ex);
      closeExpresInterestModal();
    }
  };

  const closeExpresInterestModal = () => {
    setExpresIneterestModal(false);
  };

  const params = useParams();


  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    getBrandRequestByID(params?.id, 18).then((res) => {
      setRequestDetails(res.data);
      setBrandDetails(res.brand);
      setMarketPlaceDetails(res?.brand?.market_place || []);
      setSocialMediaDetails(res?.brand?.social_media || []);
      setBrandDocumentsList(res?.brandDocuments ? res.brandDocuments : []);
    });
  }, [params, reload]);

  useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());

        if (roleDetails?.data?.type === "organization") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "10"
          );
          console.log(response);
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "5"
          );
          console.log(response);
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]);

  const getStatusTextStyle = useCallback((status: string) => {
    switch (status) {
      case "Open":
        return {
          background: "#D1E9FF",
          color: "#1570EF",
        };
      case "Matching Interests":
        return {
          background: "#FEF0C7",
          color: "#DC6803",
        };
      default:
        return {};
    }
  }, []);

  const onHandleExpressInterest = () => {
    setExpresIneterestModal(true);
  };

  const tagsList = useMemo(
    () =>
      brandDetails?.brand_categories?.map((tag: any) => {
        return (
          <div key={tag?.id} className="detailsItem">
            <img src="../svgs/tag.svg" alt="tag" className="subDetailsIcon" />
            <p className="subDetails">{tag?.categories?.name}</p>
          </div>
        );
      }),
    [brandDetails]
  );

  const documentsList = useMemo(
    () =>
      brandDocumentsList?.map((doc: any, key: number) => {
        return <DocumentItem name={doc?.filename} path={doc?.path} />;
      }),
    [brandDocumentsList]
  );

  const serviceList = useMemo(
    () =>
      requestDetails?.brand_services?.map((service: any, key: number) => {
        return <p key={key}>{service?.service?.display_name}</p>;
      }),
    [requestDetails]
  );



  const marketPlaces = useMemo(() => {
    return marketPlaceDetails?.map((item: any) => {
      let logo = ""
      switch (item?.platform) {
        case "Amazon":
          logo = "../svgs/amazon-color.svg"
          break;
        case "Alibaba":
          logo = "../svgs/alibaba-color.svg"
          break;
        case "Flipkart":
          logo = "../svgs/flipkart-color.svg"
          break;

        default:
          break;
      }

      return <Col md="auto">
        <ChipWithIcon
          icon={logo}
          text={
            item?.store_rating
              ? `${item?.store_rating}/5`
              : ""
          }
        />
      </Col>
    })
  }, [marketPlaceDetails]);

  const socialDetails = useMemo(() => {

    return socialMedialDetails?.map((item: any) => {
      const followers = item?.number_of_followers ? abbreviateNumber(item?.number_of_followers) : ""
      let logo = ""
      switch (item?.platform) {
        case "Facebook":
          logo = "../svgs/fb-color.svg"
          break;
        case "Instagram":
          logo = "../svgs/insta-color.svg"
          break;
        case "LinkedIn":
          logo = "../svgs/linkedin-color.svg"
          break;

        default:
          break;
      }

      return <Col md="auto">
        <ChipWithIcon
          icon={logo}
          text={
            item?.number_of_followers
              ? `${followers}`
              : ""
          }
        />
      </Col>
    })
  }, [socialMedialDetails])



  return (
    <Container fluid className="pge-layout">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="discovery" />
        </Col>
        <Col className="content-section view-content-section">
          <Navbar userProfile={userProfile} />
          <Breadcrumb className="font12-medium breadcrumb-nav">
            <Breadcrumb.Item
              onClick={() => {
                navigate(-1);
              }}
            >
              DISCOVERY MANAGEMENT
              {/* <Link to="/discoverymanagement/org">DISCOVERY MANAGEMENT</Link> */}
            </Breadcrumb.Item>
            <Breadcrumb.Item
              active
            // onClick={() => {
            //   navigate(-1);
            // }}
            >
              {params?.brandName?.toLocaleUpperCase()}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="detailsContainer">
            <div className="brandDetailsContainer">
              <div className="cardSection brandDetails">
                <Row className="brandTitleContainer">
                  <Avatar
                    sx={{ bgcolor: "#EFF8FF", color: "#0152FB" }}
                    aria-label="dp"
                  >
                    {getLogoPlaceHolder(requestDetails?.brand?.brand_name)}
                  </Avatar>
                  <Col md="auto">
                    <p className="brandTitle">
                      {requestDetails?.brand?.brand_name}
                    </p>
                    <p className="subDetails">
                      {requestDetails?.brand?.website}
                    </p>
                  </Col>
                  <Col md="auto">
                    <p
                      className="statusText"
                      style={getStatusTextStyle(
                        requestDetails?.status
                          ? [
                            "Interest Expressed",
                            "Interest Accepted",
                            "Matching In Progress",
                          ].includes(requestDetails.status)
                            ? "Matching Interests"
                            : requestDetails.status
                          : ""
                      )}
                    >
                      {requestDetails?.status
                        ? [
                          "Interest Expressed",
                          "Interest Accepted",
                          "Matching In Progress",
                        ].includes(requestDetails.status)
                          ? "Matching Interests"
                          : requestDetails.status
                        : ""}
                    </p>
                  </Col>
                  <Col md="auto" className="marketSection">
                    <div className="detailsItem">
                      <img
                        src="../svgs/storefront.svg"
                        alt="storefront"
                        className="subDetailsIcon"
                      />
                      <p className="subDetails">
                        {
                          requestDetails?.brand?.brand_organization?.region
                            ?.name
                        }
                      </p>
                    </div>
                    {tagsList}
                  </Col>
                  <Col style={{ paddingRight: "0" }}>
                    <Row style={{ justifyContent: "end" }}>
                      {["Interest Expressed", "Interest Accepted"].includes(requestDetails.status) ? (
                        <Col md="auto">
                          <Button
                            onClick={() => {
                              const chatData = {
                                brand_name: requestDetails.brand.brand_name,
                                brand_id: requestDetails.brand_id,
                                partner_id: userProfile.partnerv2_id,
                                brandName: requestDetails.brand.brand_name,
                                company_name: userProfile.partnerv2.name,
                                market: requestDetails.country.name,
                              };
                              setChatData(chatData);
                              setShowChatModal(true);
                            }}
                            className="btn-ter22"
                          >
                            Chat
                          </Button>
                        </Col>
                      ) : (
                        <></>
                      )}



                      {["Interest Expressed", "Interest Accepted"].includes(requestDetails.status) ? (

                        requestDetails.status === "Interest Expressed" ? (<Col md="auto"><div className="label-interested">
                          {requestDetails.status}
                        </div></Col>) : (<></>)
                      ) : (
                        <Col md="auto">
                          <Button
                            onClick={onHandleExpressInterest}
                            className="btn-primary12 adduser"
                          >
                            Express Interest
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
                <Divider />
                <Row className="ratingSection">
                  <Col className="ratings">
                    <Row className="ratingSubSection">
                      <p className="subtitle">Marketplace</p>
                      <div className="chipsContainer">
                        {marketPlaces}
                      </div>
                    </Row>
                    <Row className="ratingSubSection">
                      <p className="subtitle">Social Media</p>
                      <div className="chipsContainer">
                        {socialDetails}
                      </div>
                    </Row>
                  </Col>
                  <Col className="documentsSection">
                    <p className="subtitle">Brand Documents</p>
                    <div className="documentsList">
                      {brandDocumentsList.length > 0 ? (
                        documentsList
                      ) : (
                        <p className="subDetails">No documents available.</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="cardSection marketDetails">
                <Row>
                  <Col md="auto" className="detailItem">
                    <p className="itemLabel">Market</p>
                    <p className="itemValue">{requestDetails?.country?.name}</p>
                  </Col>
                  <Col md="auto">
                    <p className="itemLabel">Preferred Model</p>
                    <p className="itemValue">
                      {requestDetails?.engagement_model?.display_name}
                    </p>
                  </Col>
                </Row>
                <Divider />
                <Row>
                  <p className="subtitle">Required Services</p>
                  <div className="servicesContainer">{serviceList}</div>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row >
      <ConfirmModal
        haveIcon={false}
        isModalOpen={expresInterestModal}
        submit={onExpressInterest}
        closeModal={closeExpresInterestModal}
        submitBtnText="Express"
        cancelBtnText="Cancel"
        title="Express Interest"
        bodyText="Are you sure you want to express partner interest ?"
      />
      <PartnerChat
        isModalOpen={showChatModal}
        onCancel={handleChatModal}
        chatData={chatData}
        userID={userID}
      />
    </Container >
  );
}

export default BrandRequestPartnerView;
